export const PAYWALL_INTENTS = [
  "chat_message",
  "chat_image",
  "image_generation",
  "voice_message",
  "phone_call",
  "character_creation",
  "memory",
  "premium_model",
  "generic",
] as const

export type PaywallIntent = (typeof PAYWALL_INTENTS)[number]

const PAYWALL_INTENT_SET = new Set<string>(PAYWALL_INTENTS)
const OPAQUE_CHARACTER_ID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

/** Accept only the product's finite paywall vocabulary before analytics capture. */
export function parsePaywallIntent(value: string | null | undefined): PaywallIntent | null {
  return value && PAYWALL_INTENT_SET.has(value) ? (value as PaywallIntent) : null
}

/** Character identifiers are opaque UUIDs. Reject query text before it reaches analytics. */
export function parseOpaqueCharacterId(value: string | null | undefined): string | null {
  return value && OPAQUE_CHARACTER_ID_RE.test(value) ? value : null
}
